// This import loads the firebase namespace along with all its type information.
import MediaCache from './media-cache-model'

export async function load_mediaCaches(): Promise<MediaCache[]> {
  throw 'Not implemented'
}

export async function delete_mediaCache(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediaCache(): Promise<MediaCache> {
  throw 'Not implemented'
}
